import React, { useEffect, useState } from 'react';
import { getNews } from '../../utils/api';

import { Link } from 'react-router-dom';

const News = () => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const data = await getNews();
                // Greife auf das Array der News zu
                if (Array.isArray(data.news)) {
                    // Sortiere die News nach Datum in absteigender Reihenfolge
                    const sortedNews = data.news.sort((a, b) => new Date(b.date) - new Date(a.date));
                    // Nimm nur die ersten 6 News
                    setNews(sortedNews.slice(0, 6));
                } else {
                    console.error("Fehler: 'news' ist kein Array", data);
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchNews();
    }, []);

    const formatDate = (isoString) => {
        const date = new Date(isoString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-basiert
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}.${month}.${year} um ${hours}:${minutes} Uhr`;
    };

    return (
        <>
            <div className='category'>Aktuelle News</div>
            <div className='short-news'>
                {news.map((news) => (
                    <Link to={`/news/${news.site_name}`} viewTransition>
                        <div key={news.ID} className='news-short'>
                            <img src={`/news/bilder/${news.image}`} alt={news.headline} title={news.headline}/>
                            <div>
                                <div className='datetime'>
                                    {formatDate(news.date)}
                                </div>
                                <div className='title'>
                                    {news.headline}
                                </div>
                                <div className='author'>
                                    {news.author}
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </>
    );
};

export default News;